import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ObjektNutzungsQuerySorterConfig } from 'fa-kt.types';
import { ObjektNutzungsService } from '../service';

@Component({
  selector: 'fa-kt-objekt-nutzungs-sorter',
  templateUrl: './objekt-nutzungs-sorter.component.html',
  styleUrls: ['./objekt-nutzungs-sorter.component.css'],
})
export class ObjektNutzungsSorterComponent {
  ObjektNutzungsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objektNutzungs: ObjektNutzungsService,
  ) {
    this.ObjektNutzungsSorterConfig = ObjektNutzungsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
